<template>
    <div class="large-bar" @click="changeCor">
            <div class="radio-component large-bar-radio">
                <input type="radio" :id="idRadio" :value="valor" name="options" > 
            <label :for="idRadio" >
                <span class="input-box">
                    <span class="input-box-circle">
                    </span>
                </span> 
            </label>
            </div>
            <p>
                {{txt}}
            </p>
    </div>
</template>
<script>
export default {
    props:['txt','idRadio','valor'],
    methods:{
      changeCor(){
          let inputs = document.querySelectorAll('input[name="options"]')
          console.log(inputs)
          inputs.forEach(e=>{
              console.log(e.checked)
              e.checked ? e.parentElement.parentElement.style.background = '#ff9b9b' : e.parentElement.parentElement.style.background = '#eee'
          })
    }
    },
    model: {
            prop: 'modelValue',
            event: 'change'
    },    

}

</script>
